<div class="main">
  @if(!isHistory){

  <div class="filterContainer">
    @for(filterList of filterLists;track i; let i = $index) {
    @if(checkForRender(filterList.HideWithHeaderIndex)){
    <app-AutoDropdown [(SelectedValue)]="filterList.selectedValue" [onChangeFunction]="checkAndRunOnChange"
                      [items]="filterList.items" [displayProperty]="filterList.displayProperty" label="{{ filterList.label }}">
    </app-AutoDropdown>

    } } @for(multiSelectFilterList of multiSelectFilterLists;track j; let j =
    $index) { @if(checkForRender(multiSelectFilterList.HideWithHeaderIndex)){

    <AutoMultiselect [placeholderText]="multiSelectFilterList.placeHolderText" class="MultiSelector"
                     [(items)]="multiSelectFilterList.Items" (SelectedValueChange)="multiSelectFilterList.selectedValueChange($event)"
                     [onChangeFunction]="checkAndRunOnChange">
    </AutoMultiselect>
    } }
    @for(checkbox of checkboxes;track i; let i = $index) {
    <mat-checkbox class="borrowed-checkbox"
                  [(ngModel)]="checkbox.binding"
                  (ngModelChange)="checkbox.onchanged($event)">
      {{checkbox.text}}
    </mat-checkbox>
    }
  </div>
  }
  <div class="list-button-container">
    @if (listView && !isHistory) {
    <div class="buttonContainer">
      @if (confirmSelected && !multieditMode &&
      !this.listView.chooseTabledata ) {
      <button mat-flat-button color="accent" class="massEditBtn"
        (click)="multieditMode = !multieditMode">
        Rediger flere
      </button>
      } @if (confirmSelected && multieditMode) {
      <button mat-flat-button color="accent" class="massEditBtn" (click)="multieditMode = false">
        Annuller
      </button>
      } @if (confirmSelected && multieditMode) {
      <button mat-flat-button color="accent" class="massEditBtn" [disabled]="selectedCount === 0"
        (click)="confirmSelected(listView.getCheckedRows())">
        Rediger valgte
      </button>
      } @if ( !multieditMode && !this.listView.chooseTabledata &&
      !this.isHistory && createNew) {
      <button mat-flat-button color="accent" class="createBtn" (click)="createNew()">
        {{ newItemLabel }}
      </button>
      }
    </div>
    } @if (!isHistory) {
    <div class="list-container">
      <lib-list-view-v2
          #listView
          [headerList]="headersList"
          [listData]="listDataSignal()"
          (rowClick)="onRowClick($event)"
          [filterFunction]="compiledFunctionSignal()"
          [multieditmode]="multieditMode"
          [extraBurgerMenuOptions]="extraBurgerMenuOptions"
                        >
      </lib-list-view-v2>
    </div>
    } @if (isHistory) {
    <div class="list-container">
      <lib-list-view-v2
          #logListView
          [headerList]="logHeaderList"
          [listData]="logListDataSignal()"
          [extraBurgerMenuOptions]="extraBurgerMenuOptions"
                 >
      </lib-list-view-v2>
    </div>
    }
  </div>
</div>
